import { render, staticRenderFns } from "./EmpAccountManage.vue?vue&type=template&id=acc70894&scoped=true"
import script from "./EmpAccountManage.vue?vue&type=script&lang=js"
export * from "./EmpAccountManage.vue?vue&type=script&lang=js"
import style0 from "./EmpAccountManage.vue?vue&type=style&index=0&id=acc70894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc70894",
  null
  
)

export default component.exports